export default (number, sum) => number / (sum / 100);
